import React from 'react';

function toElement({
  item,
  index,
  rawIndex,
  windowSize,
  cardSize,
}) {
  if (!item) return (undefined);
  return React.cloneElement(item, {
    key: `${item.key}-${index}`,
    'aria-hidden': rawIndex <= windowSize || rawIndex > 2 * windowSize,
    cardSize,
  });
}

function createSlides(
  items,
  step,
  windowSize,
  cardSize,
  additionalCarouselItems = 0,
  convert = toElement,
) {
  if (items.length <= windowSize) {
    return items;
  }
  const total = items.length;
  const calculedStep = additionalCarouselItems > 0 ? step : step + additionalCarouselItems;
  // TODO: is there a way to refactor the logic bellow?

  const firstIndex = (total + calculedStep - (windowSize + 1)) % total;
  const transformedFirstIndex = firstIndex > 0 ? firstIndex : total + firstIndex;

  const newTotal = (windowSize * 3) + 2 + Math.abs(additionalCarouselItems);
  return Array
    .from({ length: newTotal }, (_, i) => ({
      item: items[(i + transformedFirstIndex) % total],
      index: i + transformedFirstIndex,
      rawIndex: i,
      windowSize,
      cardSize,
    }))
    .map(convert);
}

export default { createSlides };
